import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import basket from "../index"
import Basket from "@irati/checkout/errorCodes/Basket"

export const getRLOTErrorMessage = (errorKey: string, errorMessage: string, errorData: any, formatMessage: FormatMessage): string => {
  const currencyCode = basket.breakdown.total.currency
  switch (errorKey) {
    case Basket.ItemCountLimitExceeded: {
      const {limit} = errorData
      return formatMessage({id: errorMessage}, {limit})
    }
    case Basket.NotRedeemableInEventWindow: {
      const {startDate, endDate} = errorData
      return formatMessage({id: errorMessage}, {startDate, endDate})
    }
    case Basket.OpenValueMaxLimitExceeded: {
      const {amount} = errorData
      return formatMessage({id: errorMessage}, {maxValue: formatCurrency({value: amount, currencyCode})})
    }
    case Basket.OpenValueMinLimitNotReached: {
      const {amount} = errorData
      return formatMessage({id: errorMessage}, {minValue: formatCurrency({value: amount, currencyCode})})
    }
    case Basket.RedemptionAmountLimitExceeded: {
      const {limit} = errorData
      if (parseInt(limit, 10) === 0) {
        // When the limit is 0 we want to display a special error message
        return formatMessage({id: "errors.PBBTARedemptionAmountAllLimitExceeded"})
      }
      return formatMessage({id: errorMessage}, {limit: formatCurrency({value: limit, currencyCode})})
    }
    case Basket.InvalidEntityId: {
      return formatMessage({id: "errors.PBBTAInvalidEntityId"})
    }
    default:
      return errorMessage ? formatMessage({id: errorMessage}) : formatMessage({id: "errors.PBCPVUnknown"})
  }
}
